<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="7"
        viewBox="0 0 13 7"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.8861 0.721412C11.9665 0.801889 12.0053 0.893862 12.0053 0.997331C12.0053 1.10367 11.9665 1.19421 11.8861 1.27469L6.28002 6.88072C6.19955 6.9612 6.10757 7 6.00267 7C5.8992 7 5.80723 6.9612 5.72675 6.88072L0.120714 1.27469C0.0416752 1.19421 0 1.10367 0 0.997331C0 0.893862 0.0416752 0.801889 0.120714 0.721412L0.721412 0.120714C0.801889 0.0402381 0.895299 0 0.998768 0C1.10367 0 1.19565 0.0402381 1.27612 0.120714L6.00267 4.84726L10.7306 0.120714C10.8111 0.0402381 10.9031 0 11.008 0C11.1115 0 11.2034 0.0402381 11.2839 0.120714L11.8861 0.721412Z"
            fill="#046791"
        />
    </svg>
</template>
